export default function getSubFeature(isFreeDrying: boolean) {
  return isFreeDrying ? 'free_drying' : 'free_washing';
}
